/* tslint:disable */
/* eslint-disable */
/**
 * external-information-requests
 * Medicaid Pending document requests to family members, with the staff workspace and the family portal
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PortalRequestList } from './PortalRequestList';
import {
    PortalRequestListFromJSON,
    PortalRequestListFromJSONTyped,
    PortalRequestListToJSON,
    PortalRequestListToJSONTyped,
} from './PortalRequestList';

/**
 * 
 * @export
 * @interface PortalRequestListResponse
 */
export interface PortalRequestListResponse {
    /**
     * 
     */
    data: PortalRequestList;
}

/**
 * Check if a given object implements the PortalRequestListResponse interface.
 */
export function instanceOfPortalRequestListResponse(value: object): value is PortalRequestListResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function PortalRequestListResponseFromJSON(json: any): PortalRequestListResponse {
    return PortalRequestListResponseFromJSONTyped(json, false);
}

export function PortalRequestListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PortalRequestListResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': PortalRequestListFromJSON(json['data']),
    };
}

export function PortalRequestListResponseToJSON(json: any): PortalRequestListResponse {
    return PortalRequestListResponseToJSONTyped(json, false);
}

export function PortalRequestListResponseToJSONTyped(value?: PortalRequestListResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': PortalRequestListToJSON(value['data']),
    };
}

